<div class="flex column align-items-center step-layout">
  <div class="step-layout__content">
    <div class="flex column align-items-center gap-32">
      <div class="flex column align-items-center gap-4">
        <span class="typo-title-3 p-4">Verify Recovery Phrase</span>
        <span class="typo-text-2 text-align-center"
          >Please enter the requested words to confirm you've safely saved your
          recovery phrase.</span
        >
      </div>

      <div class="flex column align-items-center gap-24 full-width">
        <div class="seed-container">
          @for (item of verificationWords(); track $index) {
            <kc-input
              class="seed-container__word"
              [placeholder]="`${item.index + 1}.`"
              [infoLabel]="{ label: 'Word #' + (item.index + 1) }"
              [ngModel]="item.input"
              (valueChange)="onInputChange($index, $any($event))"
            />
          }
        </div>
      </div>
    </div>
  </div>

  <div class="step-layout__buttons">
    <div class="flex full-width gap-16">
      <div class="full-width">
        <kc-button
          [isFullWidth]="true"
          [variant]="'secondary'"
          [text]="'Back'"
          (buttonClick)="previous.emit()"
        />
      </div>
      <div class="full-width">
        <kc-button
          [isFullWidth]="true"
          [text]="'Continue'"
          [isDisabled]="!isVerified()"
          (buttonClick)="onContinue()"
        />
      </div>
    </div>
  </div>
</div>
